// import React, { useState, useEffect } from "react";
// import "./Home.css";
// import icon1 from "../../assets/card-logo.png";
// import btnimg2 from "../../assets/icons/icon-1.png";
// import apiManage from "../ManageApi/ApI";
// import { Link } from "react-router-dom";
// import cardone from "../../assets/used-images/card1.png";
// import card2 from "../../assets/used-images/card2.png";
// import card3 from "../../assets/used-images/card3.png";
// import card4 from "../../assets/used-images/card4.png";

// const staticCardsData = [
//   { icon: icon1, title: "التدريب", image: cardone, route: '/services/training' },
//   { icon: icon1, title: "موضوعات التدريب", image: card2, route: '/training-plan' },
//   { icon: icon1, title: "دورات ايفورى", image: card3, route: '/training-courses' },
//   { icon: icon1, title: "الاعتمادات", image: card4, route: '/dependencies' },
// ];

// const Cards = ({ apiData }) => {
//   // Fallback to static data if API data is empty or not available
//   const cardsData = apiData.length > 0 ? apiData : staticCardsData;

//   // Unique backgrounds for each card
//   const cardBackgrounds = [
//     cardone, 
//     card2,     
//     card3,     
//     card4      
//   ];
//   return (
//     <div className="cards-container grid grid-cols-2 lg:grid-cols-4 !gap-4 container 4">
//       {cardsData.map((card, index) => (
//         <Link
//           to={card.link ?? card.route} // Use the link from the API or fallback to static route
//           className={`card  card-${index} !w-full`}
//           key={index}
//           style={{
//             // Use the unique background for each card by referencing cardBackgrounds based on index
//             background: `linear-gradient(to bottom, rgba(106, 47, 56, 0.9) 61%, rgba(106, 47, 56, 0.7) 100%), url(${card.image ?? cardBackgrounds[index]})`,
//             backgroundSize: 'cover',
//             backgroundPosition: 'center',
//           }}
//         >
//           <div className="card-iconn cards-part">
//             {/* Fall back to icon1 if card.icon is null or undefined */}
//             <img src={card.icon ?? icon1} alt="Card Icon" />
//           </div>
//           <h3 className="cards-part">{card.title}</h3>
//           <div className="card-overlay">
//             <div className="card-icon">
//               <img src={card.icon ?? icon1} alt="Card Icon" />
//             </div>
//             <h3>{card.title}</h3>
//           </div>
//         </Link>
//       ))}
//     </div>
//   );
// };


// const Hero = () => {
//   const [currentSlide, setCurrentSlide] = useState(0); 
//   const [blogs, setBlogs] = useState([]); 
//   const [cards, setCards] = useState([]);  // State for storing card data
//   const [loading, setLoading] = useState(true); 

//   useEffect(() => {
//     const fetchBlogs = async () => {
//       try {
//         const response = await apiManage.get("/siders");
//         if (response.data.status === 200) {
//           setBlogs(response.data.data.data); 
//         }
//       } catch (error) {
//         console.error('Error fetching slider data:', error);
//       } finally {
//         setLoading(false); 
//       }
//     };

//     const fetchCards = async () => {
//       try {
//         const response = await apiManage.get("/home-pages?title_section=top_slider");
//         if (response.data.status === 200) {
//           setCards(response.data.data.data); 
//         }
//       } catch (error) {
//         console.error('Error fetching cards data:', error);
//       }
//     };

//     fetchBlogs();
//     fetchCards();
//   }, []); 

//   const moveSlide = (direction) => {
//     setCurrentSlide((prev) =>
//       (prev + direction + blogs.length) % blogs.length 
//     );
//   };
  
//   useEffect(() => {
//     const interval = setInterval(() => moveSlide(1), 5000);
//     return () => clearInterval(interval); 
//   }, [blogs.length]);

  // if (loading) {
  //   return (
  //     <div className=" ">
  //       <div className="l-load w-full h-auto px-4 py-6 rounded-md " style={{ background: '#722f37' }}>
  //         <div className="flex justify-start w-full gap-2">
  //           <div className="l-load-dt rounded-lg w-16 h-12"></div>
  //           <div className="l-load-dt rounded-lg w-16 h-12"></div>
  //         </div>
  //         <div className="w-72 h-7 rounded-lg l-load-dt my-4"></div>
  //         <div className="space-y-2 my-6">
  //           {
  //             [...Array(10)].map((_, i) => (
  //               <div key={i} className="l-load-dt h-4 w-7/12 rounded-lg"></div>
  //             ))
  //           }
  //         </div>
  //         <div className="w-44 h-14 l-load-dt rounded-lg"></div>
  //       </div>
  //     </div>
  //   )
  // };

//   return (
//     <div className="slider top-slider">
//       <div className="slides" dir="rtl" style={{ transform: `translateX(${currentSlide * 100}%)` }}>
//         {blogs.map((slide, index) => (
//           <div className="slide" key={index}>
//             <div className="hero-section"
//               style={{
//                 background: `linear-gradient(to left, rgba(106, 47, 56, 1) 38%, rgba(106, 47, 56, 0.9) 61%, rgba(106, 47, 56, 0.5) 100%), url(${slide.image})`,
//                 backgroundSize: 'cover',
//                 backgroundPosition: 'center',
//                 backgroundRepeat: 'no-repeat'
//               }}>
//               <div className="container">
//                 <div className="hero-content">
//                   <h1>{slide.title}</h1>
//                   <p>{slide.description.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ")}</p>
//                   <div className="cta-buttons">
//                     <a href="" target='_blank'> </a>
//                     <a className="btn outline" href={slide.link} target='_blank'>
//                       <img src={btnimg2} alt="btn" /> المزيد من التفاصيل
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//       <div className="slider-nav prev" onClick={() => moveSlide(-1)}>&#10095;</div>
//       <div className="slider-nav next" onClick={() => moveSlide(1)}>&#10094;</div>
//       <div className="slider-dots">
//         {blogs.map((_, index) => (
//           <div
//             key={index}
//             className={`dot ${index === currentSlide ? "active" : ""}`}
//             onClick={() => setCurrentSlide(index)}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// const Home = () => {
//   const [cards, setCards] = useState([]); // State for storing card data
//   const [loading, setLoading] = useState(true);
//   useEffect(() => {
//     const fetchCards = async () => {
//       try {
//         const response = await apiManage.get("/home-pages?title_section=top_slider");
//         if (response.data.status === 200) {
//           setCards(response.data.data.data); // Set the cards data from the API response
//         }
//       } catch (error) {
//         console.error('Error fetching cards data:', error);
//       }
//     };

//     fetchCards();
//   }, []);
//   return (
//     <div>
//       <Hero />
//       <Cards apiData={cards} /> {/* Pass the API data here for dynamic rendering */}
//     </div>
//   );
// };

// export default Home;
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import apiManage from "../ManageApi/ApI";
import icon1 from "../../assets/card-logo.png";
import btnimg2 from "../../assets/icons/icon-1.png";

import cardone from "../../assets/used-images/card1.png";
import card2 from "../../assets/used-images/card2.png";
import card3 from "../../assets/used-images/card3.png";
import card4 from "../../assets/used-images/card4.png";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useLanguage } from "../../store/language-context";
import { ArrowLeft, ChevronLeft, ChevronRight } from "lucide-react";

const Cards = ({ apiData }) => {
  const { t } = useTranslation();

  const staticCardsData = [
    { icon: icon1, title: t('routes.training'), image: cardone, route: '/services/training' },
    { icon: icon1, title: t('routes.training-plan'), image: card2, route: '/training-plan' },
    { icon: icon1, title: t('routes.training-courses'), image: card3, route: '/training-courses?page=1' },
    { icon: icon1, title: t('routes.accreditations'), image: card4, route: '/dependencies' },
  ];

  const cardsData = apiData.length > 0 ? apiData : staticCardsData;
  const cardBackgrounds = [cardone, card2, card3, card4];

  return (
    <div className="cards-container grid grid-cols-2 lg:grid-cols-4 !gap-4 container 4">
      {cardsData.map((card, index) => (
        <Link
          to={card.link ?? card.route}
          className={`card  card-${index} !w-full`}
          key={index}
          style={{
            background: `linear-gradient(to bottom, rgba(106, 47, 56, 0.9) 61%, rgba(106, 47, 56, 0.7) 100%), url(${
              card.image ?? cardBackgrounds[index]
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="card-iconn cards-part">
            <img src={card.icon ?? icon1} alt="Card Icon" />
          </div>
          <h3 className="cards-part">{card.title}</h3>
          <div className="card-overlay">
            <div className="card-icon">
              <img src={card.icon ?? icon1} alt="Card Icon" />
            </div>
            <h3>{card.title}</h3>
          </div>
        </Link>
      ))}
    </div>
  );
};

const Hero = () => {
  const { t } = useTranslation();
  const { URL  , lang} = useLanguage();
  const [currentSlide, setCurrentSlide] = useState(0); 
  const [blogs, setBlogs] = useState([]); 
  const [cards, setCards] = useState([]);  // State for storing card data
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(`${URL}/siders`);
        if (response.data.status === 200) {
          setBlogs(response.data.data.data);
        }
      } catch (error) {
        console.error("Error fetching slider data:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchCards = async () => {
      try {
        const response = await axios.get(`${URL}/home-pages?title_section=top_slider`);
        if (response.data.status === 200) {
          setCards(response.data.data.data);
        }
      } catch (error) {
        console.error("Error fetching cards data:", error);
      }
    };

    fetchBlogs();
    fetchCards();
  }, [URL, lang]); 

  const moveSlide = (direction) => {
    setCurrentSlide((prev) => (prev + direction + blogs.length) % blogs.length);
  };

  useEffect(() => {
    const interval = setInterval(() => moveSlide(1), 5000);
    return () => clearInterval(interval);
  }, [blogs.length]);

  if (loading) {
    return (
      <div className=" ">
        <div className="l-load w-full h-auto px-4 py-6 rounded-md " style={{ background: '#722f37' }}>
          <div className="flex justify-start w-full gap-2">
            <div className="l-load-dt rounded-lg w-16 h-12"></div>
            <div className="l-load-dt rounded-lg w-16 h-12"></div>
          </div>
          <div className="w-72 h-7 rounded-lg l-load-dt my-4"></div>
          <div className="space-y-2 my-6">
            {
              [...Array(10)].map((_, i) => (
                <div key={i} className="l-load-dt h-4 w-7/12 rounded-lg"></div>
              ))
            }
          </div>
          <div className="w-44 h-14 l-load-dt rounded-lg"></div>
        </div>
      </div>
    )
  }

  return (
    <div className="slider top-slider">
        <div className="slides" style={{ transform: `translateX(${currentSlide * 100}%)` }}>

        {blogs.map((slide, index) => (
          <div className="slide" key={index}>
            <div
              className="hero-section"
              style={{
                background: `linear-gradient(to left, rgba(106, 47, 56, 1) 38%, rgba(106, 47, 56, 0.9) 61%, rgba(106, 47, 56, 0.5) 100%), url(${slide.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="container">
                <div className="hero-content">
                  <h1>{slide.title}</h1>
                  <p>{slide.description.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ")}</p>
                  <div className="cta-buttons">
                    <a href="" target='_blank'> </a>
                    <a className="btn outline flex items-center gap-2 ltr:flex-row-reverse" href={slide.link} target='_blank'>
                      <img src={btnimg2} alt="btn" /> 
                      <span>
                        {t('custom.more-details')}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="slider-nav prev" onClick={() => moveSlide(-1)}><ChevronLeft className=""/></div>
      <div className="slider-nav next" onClick={() => moveSlide(1)}><ChevronRight className="" /></div>
      <div className="slider-dots">
        {blogs.map((_, index) => (
          <div key={index} className={`dot ${index === currentSlide ? "active" : ""}`} onClick={() => setCurrentSlide(index)} />
        ))}
      </div>
    </div>
  );
};

const Home = () => {
  const { URL } = useLanguage();
  const [cards, setCards] = useState([]); // State for storing card data
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchCards = async () => {
      try {
        const response = await axios.get(`${URL}/home-pages?title_section=top_slider`);
        if (response.data.status === 200) {
          setCards(response.data.data.data);
        }
      } catch (error) {
        console.error("Error fetching cards data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCards();
  }, [URL]);

  return (
    <div>
      <Hero />
      <Cards apiData={cards} />
    </div>
  );
};

export default Home;
